import { render } from "./AddCategorieHsCodeModal.vue?vue&type=template&id=1966cfee&ts=true"
import script from "./AddCategorieHsCodeModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieHsCodeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__